var url = "ecec3ccc1b78f25e5c33fbf2c1a8c164.png";
var cdnUrl = typeof _wml !== "undefined" && _wml.cdn && _wml.cdn.map(url);
module.exports = cdnUrl || __webpack_public_path__ + url;